import React, {Fragment} from 'react'
import { NavLink, withRouter} from 'react-router-dom'
import withAuthLayout from 'components/layouts/withAuthLayout';
import {ReactComponent as Logo } from  'assets/images/svg/logo.svg';
import { Formik } from 'formik';
import Swal from 'sweetalert2'

const UpdatePassword = props => {
    const { match,history} = props;
    const key = match.params.key;
return (
  <Fragment>
    <div className="row">
      <div className="w-100">
        <div className="d-flex flex-row justify-content-center">
          <Logo className="mx-auto" />
        </div>
      </div>
      <div className="col-md-7 mx-auto">
        <div className="auth-login__main">
          <h2 className="auth-login__main-header">Reset Password</h2>
          <p className="auth-login__main-info">
            Enter your new password details. Passwords must be at least 6
            characters long.
          </p>

          <div className="mt-3">
            <Formik
              initialValues={{ new_password: '', confirm_new_password: '' }}
              validate={values => {
                let errors = {};

                if (!values.new_password || values.new_password.length < 5) {
                  errors.new_password = true;
                }
                if (
                  !values.confirm_new_password ||
                  values.confirm_new_password.length < 5 ||
                  values.confirm_new_password !== values.new_password
                ) {
                  errors.confirm_new_password = true;
                }
                return errors;
              }}
              onSubmit={(values, { isSubmitting, setSubmitting }) => {
                setSubmitting(true);
                fetch(
                  `https://musicandrights.herokuapp.com/api/v1/reset_password/${key}`,
                  {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(values)
                  }
                )
                  .then(res => res.json())
                  .then(res => {
                    setSubmitting(false);
                    // console.log(res)
                    if (res.code === 200) {
                      Swal.fire({
                        type: 'success',
                        title: 'Reset Password',
                        text: res.data.message,
                        onOpen: () => {
                          setTimeout(() => {
                            Swal.clickConfirm();
                            history.push('/login');
                          }, 2000);
                        }
                      }).then(confirm => {
                        if (confirm) {
                          history.push('/login');
                        }
                      });
                    }
                    if (res.code === 400) {
                      Swal.fire({
                        type: 'error',
                        title: 'Registration failed',
                        text: res.message
                      });
                    }
                  })
                  .catch(err => {
                    setSubmitting(false);
                    // console.log(err)
                  });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <div>
                    <input
                      name="new_password"
                      className={`nsForm-input ${
                        touched.new_password && errors.new_password
                          ? 'error'
                          : null
                      }`}
                      type="password"
                      placeholder="New Password"
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <input
                      name="confirm_new_password"
                      className={`nsForm-input ${
                        touched.confirm_new_password &&
                        errors.confirm_new_password
                          ? 'error'
                          : null
                      }`}
                      type="password"
                      placeholder="Confirm Password"
                      onChange={handleChange}
                    />
                  </div>
                  <button
                    type="submit"
                    className="pill pill--secondary mt-3"
                    disabled={isSubmitting}
                  >
                    <p>{isSubmitting ? 'Please wait...' : 'Reset Password'}</p>
                  </button>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 mx-auto">
        <div className="pill pill--whitesmoke mt-4">
          <p>
            Already have an account?{' '}
            <NavLink to="/login" className="auth__link">
              Sign in
            </NavLink>
            .
          </p>
        </div>
      </div>
    </div>
  </Fragment>
);}
export default withAuthLayout(withRouter(UpdatePassword), {});